import { Injectable } from '@angular/core';

import { AppSettingsService } from 'iui-iconectiv-lib';

export class FinderInput {
  by = '';
  errMsg = '';
  boldText = '';
  input = '';
  needConfirmation ? = false;
  restLeanParams: string[] = []; // lean: TN without '-' chars
  restParams: string[] = [];
  restParamsForBeyond: string[] = [];
  tnFileName = '';
  valid = true;

  constructor(by: string) {
    this.by = by;
  }

  reset() {
    this.errMsg = '';
    this.boldText = '';
    this.input = '';
    this.needConfirmation = false;
    this.restLeanParams = [];
    this.restParams = [];
    this.restParamsForBeyond = [];
    this.tnFileName = '';
    this.valid = true;
  }
}


export class InputParams {
  byTns = new FinderInput('byTns');
  byTnFile = new FinderInput('byTnFile');
  byTnRange = new FinderInput('byTnRange');
  byCode = new FinderInput('byCode');
  byNpb = new FinderInput('byNpb');
  byNpbFile = new FinderInput('byNpbFile');
  byLrns = new FinderInput('byLrns');

  reset() {
    this.byTns.reset();
    this.byTnFile.reset();
    this.byTnRange.reset();
    this.byCode.reset();
    this.byNpb.reset();
    this.byNpbFile.reset();
    this.byLrns.reset()
  }
}


export class FinderResult {
  by: string;
  restParams: string[] = [];
  results: any[] = [];
  tnFileName = '';

  constructor(by: string) {
    this.by = by;
  }

  reset() {
    this.restParams = [];
    this.results = [];
    this.tnFileName = '';
    
  }
}


export class QueryResults {
  byTns = new FinderResult('byTns');
  byTnFile = new FinderResult('byTnFile');
  byTnRange = new FinderResult('byTnRange');
  byCode = new FinderResult('byCode');
  codeBlock = new FinderResult('byCode');
  byNpb = new FinderResult('byNpb');
  // npbTns = new FinderResult();
  tnData = new FinderResult(''); // result could be generated by various type of requested will be set later.

  reset() {
    this.byTns.reset();
    this.byTnFile.reset();
    this.byTnRange.reset();
    this.byCode.reset();
    this.codeBlock.reset();
    this.byNpb.reset();
    this.tnData.reset();
  }
}


export class TnListRequest {
  relaxed = false; // by default, only 1000 TNs will be allowed (configurable)
  tnList: string[] = [];
}


export class ValidatedNpbRequest {
  valid = true;
  invalidInput = false;
  npbRequest = '';
}


export class ValidatedTnListRequest {
  valid = true;
  invalidInputFormat = false;
  beyondMaximumUi = false;
  beyondMaximum = false;
  errorMsgs: string[] = [];
  tnListRequest = new TnListRequest();
}


export class TnRangeRequest {
  relaxed = false;
  npanxx = '';
  from = '';
  to = '';
  targetTo = '';
}


export class ValidatedTnRangeRequest {
  valid = true;
  beyondMaximumUi = false;
  needConfirmation = false;
  beyondMaximum = false;
  tnRangeRequest = new TnRangeRequest();
}


export const HUGE_NUMBER_OF_TNS = 10000;

// query input error messages
const MSG_INVALID_FORMAT = 'Invalid format.';
const MSG_INVALID_TN_RANGE = 'Invalid format. The end range cannot be less than beginning range.';
//const MSG_INVALID_TNS_TN_FORMAT = 'TN ${badTn} on line ${badTnLoc} must be 10 digits, not starting with 0 or 1. Please fix the TN.';
const MSG_INVALID_TNS_TN_FORMAT = ' All TNs must be line separated and 10 digits, not starting with 0 or 1. Please fix the TN.';
const MSG_INVALID_TN_FILE_FORMAT = ' All TNs must be line separated and 10 digits, not starting with 0 or 1. Please re-choose the file.';
const MSG_INVALID_TN = 'Invalid Format for TN ${badTn}. ';
const MSG_INVALID_TN_FILE_TN_FORMAT = 'TN ${badTn} on line ${badTnLoc} must be 10 digits, not starting with 0 or 1. Please fix the TN, and re-choose the file.';
const MSG_INVALID_TN_FILE_MAX_OUT = 'Number of TNs cannot exceed 10,000. Please fix the number of TNs, and re-choose the file.';
const MSG_INVALID_TN_MAX_OUT = 'Number of TNs cannot exceed 10,000. Please fix the number of TNs.';
const MSG_INVALID_TN_FILE_WRONG_TYPE = 'File type must be .csv or .txt. Please re-choose the file.';
// const MSG_INVALID_TN_FILE_UNKNOWN = 'Invalid format. File must contain TNs that are line separated and only 10 digits. Please re-choose the file.';
// const MSG_INVALID_TNS_UNKNOWN = 'Invalid format. Request must contain TNs that are line separated and only 10 digits.  Please fix the request.';
const MSG_INVALID_TN_FILE_REPORT_MAX_OUT = 'Number of TNs cannot exceed 500,000. Please fix the number of TNs, and re-choose the file.';
const MSG_INVALID_BLOCK = 'Invalid Format for Block ${badBlock}.';
const MSG_INVALID_LRN = 'Invalid Format for LRN ${badLrn}.';
const MSG_INVALID_BLOCK_FORMAT = 'All Blocks must be comma or line separated and only 7 digits, not starting with 0 or 1. Please fix the Block.';
const MSG_INVALID_BLOCK_FILE_FORMAT = 'All Blocks must be comma or line separated and only 7 digits, not starting with 0 or 1. Please fix the Block, and re-choose the file.';
const MSG_INVALID_BLOCK_FILE_MAX_OUT = 'Number of Blocks cannot exceed 500. Please fix the number of Blocks, and re-choose the file';
const MSG_INVALID_BLOCK_MAX_OUT = 'You have entered ${num} Blocks. The number of entered Blocks cannot exceed 500. Please fix the number of Blocks';
const MSG_INVALID_LRN_FORMAT = 'All LRNs must be comma or line separated and only 10 digits, not starting with 0 or 1. Please fix the LRN.';
const MSG_INVALID_LRN_MAX_OUT = 'You have entered ${num} LRNs. The number of entered LRNs cannot exceed 50. Please fix the number of LRNs.';
const MSG_ERROR = 'Error';
const MSG_INVALID_TN_FORMAT = '';


@Injectable()
export class SearchModelService {

  maxTnsAllowedUi: number;
  maxTnsAllowedSys: number;
  maxTnsAllowedSysForReports: number = 500000;
  maxNpbAllowedForReports: number = 500;
  maxlrnAllowedForReports: number = 50;

  constructor(private appSettings: AppSettingsService) {
    // try to get app settings loaded as soon as possible
    this.appSettings.getSettings().subscribe(s => {
      // TODO:
      this.maxTnsAllowedSys = s['max.tns.allowed.sys'] || 10000;
      this.maxTnsAllowedUi = s['max.tns.allowed.ui'] || 1000;


    });
  }


 /**
   * validate and prepare a CodeRequest object for REST call
   * 1. check against with starting 0 or 1
   * 2. remove embedded '-' char
   *
   * @param code - a FinderInput object (npa-nxx) contains Code info to be validated
   */
  validateCodeRequest(code: FinderInput) {
    code.errMsg = '';
    code.valid = true;

    code.restParams = [];
    code.restParams.push(code.input);
    code.restLeanParams = [];
    code.restLeanParams.push(code.input.replace(/\D/g, ''));

    return;
  }

  /**
   * validate and prepare a NpbRequest object for REST call
   * 1. check against with starting 0 or 1
   * 2. remove embedded '-' char
   *
   * @param npb - a FinderInput object (npa-nxx-x) contains Number Pool Block info to be validated
   */
  validateNpbRequest(npb: FinderInput) {
    npb.errMsg = '';
    npb.valid = true;
    

    npb.restParams = [];
    npb.restParams.push(npb.input);
    npb.restLeanParams = [];
    npb.restLeanParams.push(npb.input.replace(/\D/g, ''));

    return;
  }

  /**
   * validate and prepare a TnListRequest object for REST call
   *
   * @param tnList - FinderInput, its input consists of newline separated TNs to be validated
   * @param reportRequest - optional parameter if validating from a Report
   */
  validateTnListRequest(tnList: FinderInput, reportRequest: boolean = false): void {
    tnList.errMsg = '';
    tnList.boldText = '';
    tnList.valid = true;
    tnList.needConfirmation = false;

    // ensure user input file has correct file type 'csv'
    if (tnList.by === 'byTnFile') {
      const fileExtension = tnList.tnFileName.split('.').pop();

      if (fileExtension.toLowerCase() == 'csv' || fileExtension.toLowerCase() == 'txt') {
        
      } else {
        tnList.valid = false;
        tnList.errMsg = MSG_INVALID_TN_FILE_WRONG_TYPE;

        return;
      }

    }


    let inputTns: string[] = []; // for reporting errors
    let multipleTns: string[] = []; // no, empty string, no duplicates
    const validatedTnListRequest: ValidatedTnListRequest = new ValidatedTnListRequest();

    if (tnList.input) {
      // inputTns = tns.split(new RegExp('[\n]'));
      inputTns = tnList.input.replace(/[^0-9\,\n]/g,'').split(/[\n,]+/);
      //inputTns = tnList.input.replace(/\r?\n/g, '\n').replace(/ /g, '').split('\n');
      // console.log(`TO-BE-REMOVED: inputTns=${JSON.stringify(inputTns)}`);
      // remove duplicates and empty entries
      multipleTns = inputTns.filter(elem => elem !== '' );
     // console.log(inputTns);
    } //console.log("in service model"); console.log(multipleTns);
    // console.log(`TO-BE-REMOVED: multipleTns=${JSON.stringify(multipleTns)}`);
    //(`sms 221: inputTns.length=${inputTns.length}, multipleTns.length=${multipleTns.length}, this.maxTnsAllowedSys=${this.maxTnsAllowedSys}`);
    // ensure
    // 1. not null
    // 2. the number of requested TNs does not exceed 10,000.
    if (multipleTns == null || multipleTns.length === 0) {

      // detecting empty request
      tnList.valid = false;

        // if alpha characters are only entered
      if (tnList.by === 'byTns') {
        tnList.boldText = MSG_INVALID_FORMAT;
        tnList.errMsg = MSG_INVALID_TNS_TN_FORMAT;
      } else {
        tnList.boldText = MSG_INVALID_FORMAT;
        tnList.errMsg = MSG_INVALID_TN_FILE_FORMAT;
      }

    } else if ((multipleTns.length > this.maxTnsAllowedSys) && reportRequest != true) {
      // detect whether requests is beyond the maximum limit, e.g., 10000
      tnList.valid = false;
      if (tnList.by === 'byTns') {
        tnList.errMsg = MSG_INVALID_TN_MAX_OUT;
      } else {
        tnList.errMsg = MSG_INVALID_TN_FILE_MAX_OUT;
      }

    } else if ((multipleTns.length > this.maxTnsAllowedSysForReports) && reportRequest != false) {
      // detect wheather requests is beyond the max limit for report requests
      tnList.valid = false;
      tnList.boldText = MSG_ERROR;
      tnList.errMsg = MSG_INVALID_TN_FILE_REPORT_MAX_OUT;
    } else {

      // detect whether requests is beyond the UI limit, e.g., 1000
      if (multipleTns.length > this.maxTnsAllowedUi) {
        tnList.needConfirmation = true;
      }

      // ensure each TN in the list meet the following criteria:
      // 1. consists of only 10 digits
      // 2. does not start with "0" or "1"
      for (let ii = 0; ii < inputTns.length; ii++) {
        const tn = inputTns[ii];
        if (tn.length === 0) {
          continue;
        }
            // if request made by not line separating tns or are not 10 digits, display error msg byTns else byTnFile
        if (tn.length != 10 && tnList.by == 'byTns') {
          tnList.valid = false;
          //console.log("TNS invalid format message");
          tnList.errMsg = MSG_INVALID_TNS_TN_FORMAT;
          tnList.boldText = MSG_INVALID_TN.replace('${badTn}', tn);
        } else if (tn.length != 10 && tnList.by == 'byTnFile'){
          tnList.valid = false;
         // console.log("TNS file invalid format message");
          tnList.errMsg = MSG_INVALID_TN_FILE_FORMAT;
          tnList.boldText = MSG_INVALID_TN.replace('${badTn}', tn);
        }
        // console.log(`tn: [${tn}], @ line ${ii}`);
        if (/^\d+$/.test(tn) !== true || tn.startsWith('0') || tn.startsWith('1')) {
          // ensure TN consists of 10 digits
          tnList.valid = false;
         // console.log("searchtype:" + tnList.by);
         // if (tnList.by === 'byTns') {
            //tnList.errMsg = MSG_INVALID_TNS_TN_FORMAT.replace('${badTn}', tn).replace('${badTnLoc}', '' + (ii + 1));
            if (tnList.by == 'byTns') {  
              tnList.errMsg = MSG_INVALID_TNS_TN_FORMAT;
              tnList.boldText = MSG_INVALID_TN.replace('${badTn}', tn);
            } else if (tnList.by == 'byTnFile') {
              tnList.errMsg = MSG_INVALID_TN_FILE_FORMAT;
              tnList.boldText = MSG_INVALID_TN.replace('${badTn}', tn);
            }
           
         // } else {
          //  tnList.errMsg = MSG_INVALID_TN_FILE_TN_FORMAT.replace('${badTn}', tn).replace('${badTnLoc}', '' + (ii + 1));
         // }

          break;
        }
      }

      // when input is valid, prepare the REST query parameters
      if (tnList.valid) {
        tnList.boldText = '';
        tnList.restParams = [];
        tnList.restParamsForBeyond = [];
        for (let ii = 0; ii < this.maxTnsAllowedUi && ii < multipleTns.length; ii++) {
          tnList.restParams.push(multipleTns[ii]);
        }

        multipleTns.forEach((tn) => {
          tnList.restParamsForBeyond.push(tn);
        });
      }
    }

    return;
  }

  /**
   * validate and prepare a TnRangeRequest object for REST call
   * 1. ensure from range is <= to range
   * 2. determine whether confirmation is required or not
   *
   * @param tnRange - a FinderInput containing TN Range info, npa-nxx-xxxx,xxxx, to be validated
   */
  validateTnRangeRequest(tnRange: FinderInput): void {
    tnRange.needConfirmation = false;
    tnRange.errMsg = '';
    tnRange.valid = true;

    // parse the input, npa-nxx-xxxx,xxxx into npanxx, from, to
    const npanxx = tnRange.input.substr(0, 3) + tnRange.input.substr(4, 3);
    const from = tnRange.input.substr(8, 4);
    const to = tnRange.input.substr(13, 4);

    const fromInt = parseInt(from, 10);
    const toInt = parseInt(to, 10);

    if (fromInt > toInt) {
      tnRange.valid = false;
      tnRange.errMsg = MSG_INVALID_TN_RANGE;
      return;
    }

    // calculate the maximum last 4 digit of TN allowed
    let targetToInt = fromInt + this.maxTnsAllowedUi - 1;
    targetToInt = targetToInt < 9999 ? targetToInt : 9999;
    targetToInt = toInt < targetToInt ? toInt : targetToInt;
    if (targetToInt < toInt) {
      tnRange.needConfirmation = true;
    }

    // populate the rest input
    if (tnRange.needConfirmation === false) {
      tnRange.restParams.push(tnRange.input);
    } else {
      // construct new TN range
      const newTnRange = tnRange.input.substr(0, 13) + this.zeroPaddedLine(targetToInt);
      tnRange.restParams.push(newTnRange);
    }

    tnRange.restParamsForBeyond.push(tnRange.input);

    return;
  }

  /**
   * 
   * @param npb -FinderInput, its input consists of newline separated NPBs to be validated
   */
  validateNpbListRequest(npb: FinderInput) {
    npb.errMsg = '';
    npb.boldText = '';
    npb.valid = true;

    let inputNpbs: string[] = []; // for reporting errors

    if (npb.input) {

      inputNpbs = npb.input.replace(/[^0-9\,\n]/g,'').split(/[\n,]+/).filter(elem => elem !== '');

      // remove duplicates and empty entries
      inputNpbs = inputNpbs.filter((v, i, a) => a.indexOf(v) === i);

    }

    if (inputNpbs == null || inputNpbs.length === 0) {

      // detecting empty request
      npb.valid = false;

        // if alpha characters are only entered
      if (npb.by === 'byNpb') {
        npb.boldText = MSG_INVALID_FORMAT;
        npb.errMsg = MSG_INVALID_BLOCK_FORMAT;
      } else {
        npb.boldText = MSG_INVALID_FORMAT;
        npb.errMsg = MSG_INVALID_BLOCK_FILE_FORMAT;
      }

    } else if (inputNpbs.length > this.maxNpbAllowedForReports) {
      // detect whether requests is beyond the maximum limit, e.g., 500
      npb.valid = false;
      if (npb.by === 'byNpb') {
        npb.boldText = MSG_ERROR;
        npb.errMsg = MSG_INVALID_BLOCK_MAX_OUT.replace('${num}', inputNpbs.length.toString());
      } else {
        npb.boldText = MSG_ERROR;
        npb.errMsg = MSG_INVALID_BLOCK_FILE_MAX_OUT;
      }
    }

      // ensure each Block in the list meet the following criteria:
      // 1. consists of only 7 digits
      // 2. does not start with "0" or "1"
      for (let ii = 0; ii < inputNpbs.length; ii++) {
        const block = inputNpbs[ii];
        if (block.length === 0) {
          continue;
        }
        // if request made by not line separating tns or are not 7 digits, display error msg byNpb else byNpbFile
        if (block.length != 7 && npb.by == 'byNpb') {
          npb.valid = false;
          npb.errMsg = MSG_INVALID_BLOCK_FORMAT;
          npb.boldText = MSG_INVALID_BLOCK.replace('${badBlock}', block);

        } else if (block.length != 7 && npb.by == 'byNpbFile') {
          npb.valid = false;
          npb.errMsg = MSG_INVALID_BLOCK_FILE_FORMAT;
          npb.boldText = MSG_INVALID_BLOCK.replace('${badBlock}', block);
        }

          // ensure block consists of 7 digits
        if (/^\d+$/.test(block) !== true || block.startsWith('0') || block.startsWith('1')) {
          npb.valid = false;

          if (npb.by == 'byNpb') {
            npb.errMsg = MSG_INVALID_BLOCK_FORMAT;
            npb.boldText = MSG_INVALID_BLOCK.replace('${badBlock}', block);
          } else if (npb.by == 'byNpbFile') {
            npb.errMsg = MSG_INVALID_BLOCK_FILE_FORMAT;
            npb.boldText = MSG_INVALID_BLOCK.replace('${badBlock}', block);
          }

          break;
        }
      }

    if (npb.valid) {
      inputNpbs.forEach(block => {
      npb.restParams.push(block);
      });
    }
  }

    /**
   * 
   * @param lrn -FinderInput, its input consists of newline separated LRNs to be validated
   */
  validateLrnListRequest(lrn: FinderInput) {

    lrn.errMsg = '';
    lrn.boldText = '';
    lrn.valid = true;

    let inputLrns: string[] = []; // for reporting errors

    if (lrn.input) {

      inputLrns = lrn.input.replace(/[^0-9\,\n]/g,'').split(/[\n,]+/).filter(elem => elem !== '');

      // remove duplicates and empty entries
      inputLrns = inputLrns.filter((v, i, a) => a.indexOf(v) === i);

    }

    if (inputLrns == null || inputLrns.length === 0) {

      // detecting empty request
      lrn.valid = false;

        // if alpha characters are only entered
      if (lrn.by === 'byLrns') {
        lrn.boldText = MSG_INVALID_FORMAT;
        lrn.errMsg = MSG_INVALID_LRN_FORMAT;
      } 

    } else if (inputLrns.length > this.maxlrnAllowedForReports) {
      // detect whether requests is beyond the maximum limit, e.g., 500
      lrn.valid = false;
      if (lrn.by === 'byLrns') {
        lrn.boldText = MSG_ERROR;
        lrn.errMsg = MSG_INVALID_LRN_MAX_OUT.replace('${num}', inputLrns.length.toString());
      } 
    }

      // ensure each LRN in the list meet the following criteria:
      // 1. consists of only 10 digits
      // 2. does not start with "0" or "1"
      for (let ii = 0; ii < inputLrns.length; ii++) {
        const lrnVal = inputLrns[ii];
        if (lrnVal.length === 0) {
          continue;
        }
        // if request made by not line separating lrns or are not 10 digits, display error msg byLrns
        if (lrnVal.length != 10 && lrn.by == 'byLrns') {
          lrn.valid = false;
          lrn.errMsg = MSG_INVALID_LRN_FORMAT;
          lrn.boldText = MSG_INVALID_LRN.replace('${badLrn}', lrnVal);

        } 

          // ensure lrnVal consists of 10 digits
        if (/^\d+$/.test(lrnVal) !== true || lrnVal.startsWith('0') || lrnVal.startsWith('1')) {
          lrn.valid = false;

          if (lrn.by == 'byLrns') {
            lrn.errMsg = MSG_INVALID_LRN_FORMAT;
            lrn.boldText = MSG_INVALID_LRN.replace('${badLrn}', lrnVal);
          }
          break;
        }
      }

    if (lrn.valid) {
      inputLrns.forEach(lrnNum => {
      lrn.restParams.push(lrnNum);
      });
    }

  }



  /**
   * find an entry in strArray where it startswith str
   * return -1, if it is not found, else return idx + 1
   *
   * @param str
   * @param strArray
   */
  findLineNumber(str: string, strArray: string[]): number {
    for (let ii = 0; ii < strArray.length; ii++) {
      if (strArray[ii].startsWith(str)) {
        return ii + 1;
      }
    }
    return -1;
  }


  // pad line number into zero leading 4 digit string
  zeroPaddedLine(n: number): string {
    const tmp = '0000' + n;
    return tmp.substr(tmp.length - 4);
  }

}
